import clsx from "clsx";
import { Icon, Text } from "./base";

type AgentSessionOrigin = "debugger" | "web" | "phone" | "simulation" | "unknown";

type AgentSessionOriginPillProps = {
  origin: AgentSessionOrigin | string;
};

export const AgentSessionOriginPill = ({ origin }: AgentSessionOriginPillProps) => {
  const normalizedOrigin: AgentSessionOrigin =
    origin === "debugger" || origin === "web" || origin === "phone" || origin === "simulation" || origin === "unknown" ? origin : "unknown";

  const label =
    normalizedOrigin === "debugger"
      ? "Debugger"
      : normalizedOrigin === "web"
        ? "Web"
        : normalizedOrigin === "phone"
          ? "Phone"
          : normalizedOrigin === "simulation"
            ? "Simulation"
            : "Unknown";

  const iconName =
    normalizedOrigin === "debugger"
      ? "code"
      : normalizedOrigin === "web"
        ? "language"
        : normalizedOrigin === "phone"
          ? "phone"
          : normalizedOrigin === "simulation"
            ? "testing"
            : "question-mark";

  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs flex flex-row items-center gap-1",
        normalizedOrigin === "debugger" && "bg-purple-100 dark:bg-purple-900/20 text-purple-800 dark:text-purple-300",
        normalizedOrigin === "web" && "bg-blue-100 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300",
        normalizedOrigin === "phone" && "bg-success/10 dark:bg-success/20 text-success-dark dark:text-success-light",
        normalizedOrigin === "simulation" && "bg-orange-100 dark:bg-orange-900/20 text-orange-800 dark:text-orange-300",
        normalizedOrigin === "unknown" && "bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300",
      )}
    >
      <Icon
        name={iconName}
        size={11}
        className={clsx(
          "mt-0.5",
          normalizedOrigin === "debugger" && "text-purple-800 dark:text-purple-300",
          normalizedOrigin === "web" && "text-blue-800 dark:text-blue-300",
          normalizedOrigin === "phone" && "text-success-dark dark:text-success-light",
          normalizedOrigin === "simulation" && "text-orange-800 dark:text-orange-300",
          normalizedOrigin === "unknown" && "text-gray-600 dark:text-gray-300",
        )}
      />
      {label}
    </Text>
  );
};
